<template>
  <!-- You can change the layouts if needed here, just include your logic and the one you need -->
  <router-view v-bind="$props"></router-view>
</template>

<script>
import Layout from './Layout'

export default {
  name: 'JustRouter',
  props: {
    event: {
      type: Object,
    },
    events: {
      type: Array,
    },
    company: {
      type: Object,
    },
    coverImage: {
      type: Object,
    },
    coverImageMobile: {
      type: Object,
    },
  },
  components: {
    Layout,
  },
}
</script>

<style scoped></style>
